import type { Tracker } from '../../types';
import {
    awaitAdvertisingPixels,
    createMissingPixelWarning,
} from '../advertising-pixels';
import { getPinterestEvent } from './utils';

declare function pintrk(
    command: 'track',
    eventName: string,
    data?: Record<string, unknown>,
): void;

export function createPinterestTracker(): Tracker {
    const warnPixelMissing = createMissingPixelWarning('Pinterest');

    return {
        name: 'pinterestTracker',
        async log(event, opts) {
            await awaitAdvertisingPixels();

            const pinterestEventData = getPinterestEvent(event);
            if (!pinterestEventData) return;

            const { eventName } = pinterestEventData;

            if (typeof pintrk === 'undefined') {
                warnPixelMissing(eventName);
                return;
            }

            console.log(
                '%cPinterestEvent: ' + eventName,
                'background: #222; color: #bada55',
            );

            if (opts.data) {
                pintrk('track', eventName, opts.data);
            } else {
                pintrk('track', eventName);
            }
        },
        release() {
            // do nothing
        },
    };
}
